import { SPORTS } from '#lib/configs/api'
import type { MatchData } from '#lib/types'
import type { BaseResponse } from '#lib/types/api'
import { useAPI } from '#lib/composables'

export const useSportsService = () => {
  /**
   * Fetches the football match schedules.
   *
   * @returns {Promise<FetchResponse<BaseResponse<Record<string, MatchData[]>>>>} - A promise resolving to the API response containing the football schedules.
   */
  const getFootballSchedulesService = () => {
    return useAPI<BaseResponse<Record<string, MatchData[]>>>(
      SPORTS.FOOTBALL_SCHEDULE,
    )
  }

  return {
    getFootballSchedulesService,
  }
}
